
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/meet-council",
      function () {
        return require("private-next-pages/dashboard/meet-council.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/meet-council"])
      });
    }
  